import { render, staticRenderFns } from "./EmbeddedBracket.vue?vue&type=template&id=088b5aa8&scoped=true"
import script from "./EmbeddedBracket.vue?vue&type=script&lang=js"
export * from "./EmbeddedBracket.vue?vue&type=script&lang=js"
import style0 from "./EmbeddedBracket.vue?vue&type=style&index=0&id=088b5aa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088b5aa8",
  null
  
)

export default component.exports